/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guardian_Link_SuccessInputs */

const fr_guardian_link_success = /** @type {(inputs: Guardian_Link_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enfant lié à ce parent`)
};

/**

* @param {Guardian_Link_SuccessInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const guardian_link_success = /** @type {((inputs?: Guardian_Link_SuccessInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guardian_Link_SuccessInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_guardian_link_success(inputs)
});